import { Link } from "react-router-dom";
import { Code2 } from "lucide-react";

export function BrandLogo({ light = false, testid = "brand-logo", className = "", onClick }) {
  return (
    <Link to="/" data-testid={testid} onClick={onClick} aria-label="Code With Sankalp home" className={`group inline-flex items-center gap-2.5 min-w-0 ${className}`}>
      <span className="w-9 h-9 sm:w-10 sm:h-10 shrink-0 rounded-xl bg-gradient-to-br from-amber-500 to-violet-500 flex items-center justify-center shadow-[0_8px_24px_-10px_rgba(245,158,11,0.6)] transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105">
        <Code2 className="w-5 h-5 text-white" />
      </span>
      <span className="leading-tight min-w-0">
        <span className={`block font-adult-heading font-semibold text-[14px] sm:text-[15px] tracking-tight whitespace-nowrap ${light ? "text-[#2B2D42]" : "text-white"}`}>Code With Sankalp</span>
        <span className={`block mt-0.5 text-[9px] sm:text-[10px] uppercase tracking-[0.16em] sm:tracking-[0.24em] font-adult-mono whitespace-nowrap ${light ? "text-[#6B7489]" : "text-zinc-400"}`}>Code. Create. Conquer.</span>
      </span>
    </Link>
  );
}
